module.exports = __webpack_public_path__ + "static/img/bg_title@2x.6ee9229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktb/bg_title@2x.png
// module id = O5tD
// module chunks = 70